import React from 'react';
import { useContent } from '../../context/ContentContext';
import { resolveBeliefsValues } from '../../data/beliefsValues';
import EditableText from './EditableText';
import RichTextField from './RichTextField';
import { useAuth } from '../../context/AuthContext';

function EditableValueField({ index, field, tag = 'span', className = '' }) {
  const { isEditing } = useAuth();
  const { getContent, setContentValue } = useContent();
  const values = resolveBeliefsValues(getContent);
  const value = values.items[index]?.[field] || '';

  const saveValue = (nextValue) => {
    const nextItems = values.items.map((item, idx) =>
      idx === index ? { ...item, [field]: nextValue } : item
    );
    setContentValue('beliefs.values.items', nextItems);
  };

  return (
    <RichTextField
      isEditing={isEditing}
      tag={tag}
      className={className}
      value={value}
      onChange={saveValue}
      multiline={field === 'text'}
    />
  );
}

export default function EditableBeliefsValues() {
  const { getContent } = useContent();
  const values = resolveBeliefsValues(getContent);

  return (
    <section className="values-container fade-up">
      <span
        className="editor-field-anchor"
        data-content-key="beliefs.values.items"
        data-value-count={values.items.length}
        aria-hidden="true"
      />
      <div className="values-box zoom-in">
        <EditableText contentKey="beliefs.values.title" tag="h1" className="values-title">
          {values.title}
        </EditableText>
        <div className="values-content">
          {values.items.map((item, index) => (
            <p key={`value-${index}`}>
              <EditableValueField index={index} field="label" tag="span" className="highlight" />
              {' '}
              <EditableValueField index={index} field="text" tag="span" />
            </p>
          ))}
        </div>
      </div>
    </section>
  );
}
